export const TRUCKSMARTER_SUPPORT_PHONE_NUMBER = '(415) 384-5018';
